import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ roles, children }) {
  const { user, ready } = useAuth();
  if (!ready) return (
    <div className="min-h-screen flex items-center justify-center bg-[#061426] text-slate-300">
      <div className="animate-pulse">Carregando…</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
